export default {
  MANAGE_VERSION_LIST_REQUEST: 'APP/MANAGE_VERSION/MANAGE_VERSION_LIST_REQUEST',
  MANAGE_VERSION_LIST_SUCCESS: 'APP/MANAGE_VERSION/MANAGE_VERSION_LIST_SUCCESS',
  MANAGE_VERSION_LIST_ERROR: 'APP/MANAGE_VERSION/MANAGE_VERSION_LIST_ERROR',
};
